import styled from "styled-components";

export default styled.div`
  margin-top: 4rem;
  margin-bottom: 4rem;
  width: 100%;

  .home-page {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 1rem;
    flex-flow: row wrap;
    gap: 1rem;
  }

  @media screen and (max-width: 768px) {
    .home-page {
      display: flex;
      flex-flow: column nowrap;

      gap: 1rem;
    }
  }
`;
